exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-3Slmn{display:inline-block;position:relative}.link-3Slmn:not(:last-child){margin-right:20px}.link-3Slmn:not(:last-child):after{content:\"\";height:20px;width:1px;background-color:#fff;position:absolute;right:-10px}.title-1AUTh{text-transform:uppercase;font-weight:600}.active-1BdFP{color:#0a81ff}.theme-dark .link-3Slmn:not(:last-child):after{background-color:#fff}.theme-light .link-3Slmn:not(:last-child):after{background-color:#b9b9b9}", ""]);

// exports
exports.locals = {
	"link": "link-3Slmn",
	"title": "title-1AUTh",
	"active": "active-1BdFP"
};